// App.jsx
import { ChakraProvider, Box, Grid } from '@chakra-ui/react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import customTheme from './theme/theme'
import './assets/css/styles.css'
import Navbar from './components/navbar'
import Footer from './components/footer'
import HomePage from './pages/home/home'
import ContactPage from './pages/contact_us/contact_us'
import ScrollToTop from './hooks/ScrollToTop'

import "@fontsource/inter/400.css";
import "@fontsource/inter/700.css";

import "@fontsource/roboto-condensed/400.css";
import "@fontsource/roboto-condensed/700.css";
import ServicesPage from './pages/services/services'
import AboutUsPage from './pages/about-us/about-us'


function App() {
  return (
    <ChakraProvider theme={customTheme}>
      <Router>
        <ScrollToTop />
        <Grid minH="100dvh" gridTemplateRows="auto 1fr auto">
          <Navbar />
          <Box pt={16}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/about-us" element={<AboutUsPage />} />
              <Route path="/services" element={<ServicesPage />} />
            </Routes>
          </Box>
          <Footer />
        </Grid>

      </Router>
    </ChakraProvider>
  )
}

export default App
